/**
 * Вход через VK ID / Яндекс ID создаёт аккаунт с пустой анкетой (#1279). Раньше такой
 * пользователь попадал в ленту, получал 403 PROFILE_INCOMPLETE и окно «Заполните
 * анкету», а оттуда — редактор профиля с обязательным полем Email (там лежала
 * заглушка `vk_…@vk.oauth`). Теперь его сразу ведут в визард регистрации без шага
 * email/пароля — `/register/complete`.
 *
 * Решение принимает сервер (признак `oauthRegistrationPending` в профиле): по
 * суффиксу email на фронте ничего не угадываем. Вход по email/телефону и любая
 * заполненная анкета — без изменений.
 */
import type { ProfileResponse } from "../services/types";

type GateUser = Pick<ProfileResponse, "profileCompleted" | "oauthRegistrationPending"> | null | undefined;

/** Нужно ли вести пользователя в OAuth-визард вместо вкладок приложения. */
export function needsOauthRegistration(user: GateUser): boolean {
    return Boolean(user && user.oauthRegistrationPending && !user.profileCompleted);
}
